import React from "react";
import { usePaymentVerify } from "../hooks/usePaymentVerify";
import "./PaymentCallback.css";

const StatusIcon = ({ status }) => {
  if (status === "verifying") return <div className="status-spinner" />;
  if (status === "success") return <div className="status-icon success">✓</div>;
  if (status === "cancelled") return <div className="status-icon cancelled">✕</div>;
  return <div className="status-icon failed">!</div>;
};

const PaymentCallback = () => {
  const { status, details, error } = usePaymentVerify();

  const handleRetry = () => {
    window.location.href = "/";
  };

  return (
    <div className="callback-wrapper">
      <div className="callback-card">
        <StatusIcon status={status} />

        {status === "verifying" && (
          <>
            <h2 className="callback-title">Verifying Payment</h2>
            <p className="callback-msg">Please wait while we confirm your payment…</p>
          </>
        )}

        {status === "success" && (
          <>
            <h2 className="callback-title success-text">Payment Successful!</h2>
            <p className="callback-msg">
              Your nomination has been received and payment confirmed.
            </p>
            {details && (
              <div className="receipt">
                {details.email && (
                  <div className="receipt-row">
                    <span className="receipt-key">Email</span>
                    <span className="receipt-val">{details.email}</span>
                  </div>
                )}
                {details.amount && (
                  <div className="receipt-row">
                    <span className="receipt-key">Amount</span>
                    <span className="receipt-val">
                      ₦{Number(details.amount).toLocaleString()}
                    </span>
                  </div>
                )}
                {details.tx_ref && (
                  <div className="receipt-row">
                    <span className="receipt-key">Reference</span>
                    <span className="receipt-val mono">{details.tx_ref}</span>
                  </div>
                )}
              </div>
            )}
            <button className="action-btn primary" onClick={handleRetry}>
              Submit Another Nomination
            </button>
          </>
        )}

        {status === "cancelled" && (
          <>
            <h2 className="callback-title">Payment Cancelled</h2>
            <p className="callback-msg">
              Your payment was cancelled. No charges were made.
            </p>
            <button className="action-btn secondary" onClick={handleRetry}>
              Try Again
            </button>
          </>
        )}

        {status === "failed" && (
          <>
            <h2 className="callback-title failed-text">Payment Failed</h2>
            <p className="callback-msg">
              {error || "We could not verify your payment. Please contact support if you were charged."}
            </p>
            <button className="action-btn secondary" onClick={handleRetry}>
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentCallback;
